<!--
 * @Author: DXG
 * @Date: 2024-05-08 14:47:48
 * @LastEditors: DXG
 * @LastEditTime: 2024-05-11 09:53:16
 * @FilePath: \kdtup-pc-web\src\bizcomponents\general\generalBuy.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<!--
Author: TangChen
Date: 2019-01-03
Desc: 购买定投基金，由index.js 配置引入
-->
<template>
    <div>
        <comp-title-dc back-url-name="myplan" :back-url-query="{ planType: 0 }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/myplan' }">我的定投</el-breadcrumb-item>
                <el-breadcrumb-item v-if="fund.isCom" :to="{ path: '/myplan' }">
                    组合定投
                </el-breadcrumb-item>
                <el-breadcrumb-item v-if="!fund.isCom">新增定投协议</el-breadcrumb-item>
                <el-breadcrumb-item v-if="fund.isCom">设置及确认</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div>
            <plan-buy v-if="fund.fundcode || fund.isCom" :general-fund="fund" />
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import planBuy from "@/components/fund/planBuy";
export default {
    name: "GeneralBuy",
    components: {
        planBuy
    },
    mixins: [mixin],
    data() {
        return {
            fund: {}
        };
    },
    mounted() {
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
    },
    methods: {}
};
</script>
<style lang="scss">
.bizcomp-general-buy {
    padding-bottom: 30px;
}
</style>
